import Box from '@mui/material/Box'

export const Oval = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: '#F2F2F2',
      borderRadius: '9999px',
      position: 'absolute',
      width: 240,
      height: 40,
      zIndex: 1,
    }}
  />
)
